import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

import firebase from "firebase";

export const { useUser, UserContext, UserProvider } = CreateAuthentication(
  firebase,
  process.env.REACT_APP_FIREBASE_AUTHDOMAIN
);
